import React, { useState } from 'react'
import axios from 'axios'
import { Button } from 'antd'
import { Spinner } from 'react-spinners-css'
import { Box } from 'layout'

import { conversationURL } from 'global'

export default function ScreenSelectChatRooms ({ nickname, onFinish, onReturn }) {
  const [rooms, setRooms] = useState()
  const [error, setError] = useState(null)

  console.log('conversationURL', conversationURL)
  if (!rooms) {
    setTimeout(async () => {
      try {
        const res = await axios.get(conversationURL)
        setRooms(res.data)
      } catch {
        setError("Can't connect to the chat server.")
      }
    })

    if (error) {
      return (
        <Box>
          <h1 style={{ marginLeft: 10 }}>Select a Chat-Room</h1>
          <p>
            <strong>Error:</strong> {error}
          </p>
          <Button onClick={() => onReturn()}>Return to last page.</Button>
        </Box>
      )
    }

    return (
      <Box>
        <h1 style={{ marginLeft: 10 }}>Select a Chat-Room</h1>
        <Spinner color='#000' />
      </Box>
    )
  }

  return (
    <Box>
      <h1 style={{ marginLeft: 10 }}>Select a Chat-Room</h1>
      <ul>
        {rooms.map(room => {
          return (
            <li key={room.Sid}>
              <Button onClick={() => onFinish(room)}>{room.FriendlyName}</Button>
            </li>
          )
        })}
      </ul>
    </Box>
  )
}
